import { useCallback } from 'react';
import { SHOW_MODAL } from 'Reducers/modal/types';
import i18n from 'Utilities/i18n';
import { store } from 'Utilities/store';
import { resendVerificationEmail } from 'Services/patient';
const useResendVerificationEmail = ({ account_id, osType, osVersion, app, appVersion, handleApiRequestError, }) => {
    const handleResendEmailButtonClick = useCallback(async () => {
        try {
            await resendVerificationEmail(account_id, osType, osVersion, app, appVersion);
            store.dispatch({
                type: SHOW_MODAL,
                modalProps: {
                    details: i18n.t('CheckYourEmailRegistration.modals.checkEmailDialog.body'),
                },
            });
        }
        catch (err) {
            const error = err;
            handleApiRequestError(error);
        }
    }, [account_id, osType, osVersion, app, appVersion, handleApiRequestError]);
    return { handleResendEmailButtonClick };
};
export default useResendVerificationEmail;
